/* =============================================================================
   Product Page JS
   assets/product-page.js
   ============================================================================= */

(function () {
  'use strict';

  /* --- Gallery: thumbnail switching --- */
  const gallery = document.getElementById('product-gallery');
  if (gallery) {
    const slides = gallery.querySelectorAll('.product-gallery__slide');
    const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.index, 10);
        slides.forEach((s) => s.classList.remove('is-active'));
        thumbs.forEach((t) => t.classList.remove('is-active'));
        if (slides[index]) slides[index].classList.add('is-active');
        thumb.classList.add('is-active');
      });
    });
  }

  /* --- Quantity stepper --- */
  const qtyInput    = document.getElementById('product-qty');
  const qtyDecrease = document.getElementById('qty-decrease');
  const qtyIncrease = document.getElementById('qty-increase');

  if (qtyInput && qtyDecrease && qtyIncrease) {
    qtyDecrease.addEventListener('click', () => {
      const val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyIncrease.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* --- Variant selection --- */
  const productData  = window.productJSON || null;
  const variantInput = document.getElementById('variant-id');
  const optionBtns   = document.querySelectorAll('.product-info__option-btn');

  if (optionBtns.length && variantInput) {
    const selectedOptions = {};

    /* Initialise from active buttons */
    document.querySelectorAll('.product-info__option-btn.is-selected').forEach((btn) => {
      selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
    });

    optionBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.optionPosition;
        /* Deselect siblings */
        document.querySelectorAll(`.product-info__option-btn[data-option-position="${pos}"]`).forEach((b) => {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        selectedOptions[pos] = btn.dataset.optionValue;

        /* Update display label */
        const label = document.getElementById(`selected-${pos}`);
        if (label) label.textContent = btn.dataset.optionValue;
      });
    });
  }

  /* --- Add to cart (product form) --- */
  const form       = document.getElementById('product-form');
  const atcBtn     = document.getElementById('add-to-cart-btn');
  const stickyBtn  = document.getElementById('sticky-atc-btn');

  async function addToCart(e) {
    e?.preventDefault();
    if (!form || !atcBtn) return;

    const variantId = document.getElementById('variant-id')?.value;
    const qty       = parseInt(document.getElementById('product-qty')?.value || '1', 10);

    if (!variantId) return;

    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });
      if (!res.ok) throw new Error();

      atcBtn.textContent = 'Added!';
      setTimeout(() => {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
      }, 1800);

      /* Refresh cart drawer + count */
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      if (window.renderCartDrawer) window.renderCartDrawer(cart);

    } catch {
      atcBtn.textContent = 'Try again';
      atcBtn.disabled = false;
    }
  }

  if (form) form.addEventListener('submit', addToCart);
  if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

  /* --- Sticky ATC: show after scrolling past main ATC --- */
  const stickyAtc = document.getElementById('sticky-atc');
  const mainAtc   = document.getElementById('add-to-cart-btn');

  if (stickyAtc && mainAtc) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
        stickyAtc.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      },
      { threshold: 0 }
    );
    observer.observe(mainAtc);
  }

})();
